import { useDispatch } from "react-redux";
import { setLoading, setNotifications, setResetInterval, } from "../slices/notificationsSlice";
import { fetchNotifications } from "./fetchNotifications";
import client from "./client";
import { useNotificationsSelector } from "screens/Root/hooks/useAppSelector";
import { getRootApi } from "meta/utils/getRootApi";
export const useNotifications = () => {
    const { loading, resetInterval } = useNotificationsSelector();
    const dispatch = useDispatch();
    const broadcastNotificationsLoaded = () => {
        getRootApi().FrontendEvents.webEvent({ type: "NOTIFICATIONS_LOAD_COMPLETED" }, window.name);
    };
    const updateNotifications = async (noCache = false) => {
        dispatch(setLoading(true));
        dispatch(setResetInterval(false));
        await client.loadNotifications(noCache);
        dispatch(setResetInterval(true));
        dispatch(setLoading(false));
        broadcastNotificationsLoaded();
        await loadNotifications();
    };
    const loadNotifications = async () => {
        const grouped = await fetchNotifications();
        dispatch(setNotifications(grouped));
    };
    return { loading, resetInterval, updateNotifications };
};
